const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const prmedia_thermatru_company_background = {
    area :'PR & Media Therma-Tru',
    title: 'Company Background',
    ref : 'prmedia_thermatru_company_background',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Therma-Tru_Backgrounder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru',
}